/* eslint-disable max-len */
// Dependencies
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import {Button, Input, Modal2} from '@lazarusai/forms-ui-components'
import stylesPromptModal from '../styles/PromptModal.module.css'
import {setEditPrompt} from '../actions/setEditPrompt'

// Components

function PromptModal(props) {
  const [isPromptModalShowing, setIsPromptModalShowing] = useState(false)
  const [editablePrompts, setEditablePrompts] = useState(null)

  useEffect(() => {
    setIsPromptModalShowing(window.location.search?.includes('editable'))
  }, [window.location.search])

  useEffect(() => {
    if (props.editPrompts && !editablePrompts) {
      setEditablePrompts(structuredClone(props.editPrompts))
    }
  }, [props.editPrompts])

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: '4',
      }}
    >
      <Modal2
        isVisible={isPromptModalShowing}
        theme={props.theme}
        height={'90'}
        width={'90'}
        style={{
          position: 'fixed',
          height: '90vh',
          width: '90vw',
          minWidth: '500px',
          minHeight: '300px',
        }}
        showConfirm={false}
        showClose={true}
        onDismiss={() => {
          setIsPromptModalShowing(false)
        }}
        title={'Prompt Edit'}
        hasLine={false}
        className={stylesPromptModal['edit-modal']}
        contentContainerStyle={{overflowY: 'auto'}}
      >
        {Object.keys(props.editPrompts || {}).map((moduleKey, mIndex) => {
          return (
            <>
              <h3>{moduleKey}</h3>
              {Object.keys(props.editPrompts?.[moduleKey] || {}).map((taskKey, tIndex) => {
                return (
                  <div
                    key={`${moduleKey}-${taskKey}`}
                    style={{
                      paddingLeft: '8px',
                      width: 'calc(100% - 20px)',
                      boxSizing: 'border-box',
                    }}
                  >
                    <Input
                      label={`${moduleKey} ${taskKey}`}
                      theme={props.theme}
                      onChange={(e) => {
                        const copyEditPrompt = structuredClone(editablePrompts)
                        copyEditPrompt[moduleKey][taskKey] = e.target.value
                        setEditablePrompts(copyEditPrompt)
                      }}
                      type={2}
                      value={editablePrompts?.[moduleKey]?.[taskKey]}
                    />
                    {(editablePrompts?.[moduleKey]?.[taskKey] !== props.editPrompts?.[moduleKey]?.[taskKey]) &&
                      <Button
                        text={`Save ${moduleKey} ${taskKey}`}
                        onClick={() => {
                          props.setEditPrompt(
                              props.database,
                              moduleKey,
                              taskKey,
                              editablePrompts?.[moduleKey]?.[taskKey],
                          )
                        }}
                        theme={props.theme}
                      />
                    }
                  </div>
                )
              })}
            </>
          )
        })}
      </Modal2>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  editPrompts: state.userReducer.editPrompts,
})

export default connect(
    mapStateToProps,
    {setEditPrompt},
)(PromptModal)
